import { Tooltip } from 'antd';
import { Button } from '@mui/material';

const UpdateButton = ({ title, type = 'submit', disabled }) => {
	return (
		<Tooltip title={title}>
			<Button
				type={type}
				disabled={disabled}
				variant="contained"
				sx={{
					width: '6rem',
					fontSize: '13px',
					fontWeight: '500',
					lineHeight: 1.75,
					borderRadius: '6px',
					padding: '7px 16px',
					color: 'common.white',
					transition: 'all 0.1s',
					bgcolor: 'rgb(3, 57, 108)',

					'&:hover': { bgcolor: disabled ? '#0000001f' : 'rgb(3, 57, 108)', transform: disabled ? 'none' : 'scale(1.05)' },
				}}
			>
				{title}
			</Button>
		</Tooltip>
	);
};

export default UpdateButton;
